/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { tagControllerCreate } from '../fn/tag/tag-controller-create';
import { TagControllerCreate$Params } from '../fn/tag/tag-controller-create';
import { tagControllerDelete } from '../fn/tag/tag-controller-delete';
import { TagControllerDelete$Params } from '../fn/tag/tag-controller-delete';
import { tagControllerFindAll } from '../fn/tag/tag-controller-find-all';
import { TagControllerFindAll$Params } from '../fn/tag/tag-controller-find-all';
import { tagControllerFindById } from '../fn/tag/tag-controller-find-by-id';
import { TagControllerFindById$Params } from '../fn/tag/tag-controller-find-by-id';
import { tagControllerSearchCursor } from '../fn/tag/tag-controller-search-cursor';
import { TagControllerSearchCursor$Params } from '../fn/tag/tag-controller-search-cursor';
import { tagControllerSearchOffset } from '../fn/tag/tag-controller-search-offset';
import { TagControllerSearchOffset$Params } from '../fn/tag/tag-controller-search-offset';
import { tagControllerUpdate } from '../fn/tag/tag-controller-update';
import { TagControllerUpdate$Params } from '../fn/tag/tag-controller-update';
import { TagDto } from '../models/tag-dto';
import { TagSearchResponseDto } from '../models/tag-search-response-dto';

@Injectable({ providedIn: 'root' })
export class TagService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tagControllerFindAll()` */
  static readonly TagControllerFindAllPath = '/api/tags';

  /**
   * 모든 태그 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerFindAll$Response(params?: TagControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TagDto>>> {
    return tagControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 태그 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerFindAll(params?: TagControllerFindAll$Params, context?: HttpContext): Observable<Array<TagDto>> {
    return this.tagControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TagDto>>): Array<TagDto> => r.body)
    );
  }

  /** Path part for operation `tagControllerCreate()` */
  static readonly TagControllerCreatePath = '/api/tags';

  /**
   * 태그 등록.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tagControllerCreate$Response(params: TagControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
    return tagControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 태그 등록.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tagControllerCreate(params: TagControllerCreate$Params, context?: HttpContext): Observable<TagDto> {
    return this.tagControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagDto>): TagDto => r.body)
    );
  }

  /** Path part for operation `tagControllerSearchOffset()` */
  static readonly TagControllerSearchOffsetPath = '/api/tags/search/offset';

  /**
   * 태그 오프셋 기반 조회.
   *
   * 태그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerSearchOffset$Response(params: TagControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<TagSearchResponseDto>> {
    return tagControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 태그 오프셋 기반 조회.
   *
   * 태그를 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerSearchOffset(params: TagControllerSearchOffset$Params, context?: HttpContext): Observable<TagSearchResponseDto> {
    return this.tagControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagSearchResponseDto>): TagSearchResponseDto => r.body)
    );
  }

  /** Path part for operation `tagControllerSearchCursor()` */
  static readonly TagControllerSearchCursorPath = '/api/tags/search/cursor';

  /**
   * 태그 커서 기반 조회.
   *
   * 태그를 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerSearchCursor$Response(params: TagControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return tagControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 태그 커서 기반 조회.
   *
   * 태그를 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerSearchCursor(params: TagControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.tagControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `tagControllerFindById()` */
  static readonly TagControllerFindByIdPath = '/api/tags/{id}';

  /**
   * 태그 ID 기반 조회.
   *
   * 태그를 ID 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerFindById$Response(params: TagControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
    return tagControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 태그 ID 기반 조회.
   *
   * 태그를 ID 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerFindById(params: TagControllerFindById$Params, context?: HttpContext): Observable<TagDto> {
    return this.tagControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagDto>): TagDto => r.body)
    );
  }

  /** Path part for operation `tagControllerDelete()` */
  static readonly TagControllerDeletePath = '/api/tags/{id}';

  /**
   * 태그 삭제.
   *
   * 태그를 삭제합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerDelete$Response(params: TagControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
    return tagControllerDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * 태그 삭제.
   *
   * 태그를 삭제합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tagControllerDelete(params: TagControllerDelete$Params, context?: HttpContext): Observable<TagDto> {
    return this.tagControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagDto>): TagDto => r.body)
    );
  }

  /** Path part for operation `tagControllerUpdate()` */
  static readonly TagControllerUpdatePath = '/api/tags/{id}';

  /**
   * 태그 수정.
   *
   * 태그를 수정합니다
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tagControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tagControllerUpdate$Response(params: TagControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TagDto>> {
    return tagControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 태그 수정.
   *
   * 태그를 수정합니다
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tagControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tagControllerUpdate(params: TagControllerUpdate$Params, context?: HttpContext): Observable<TagDto> {
    return this.tagControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TagDto>): TagDto => r.body)
    );
  }

}
